module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/discards/discards-list/discards-list.component.sass
// module id = ./src/app/discards/discards-list/discards-list.component.sass
// module chunks = main